import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { jwtDecode } from "jwt-decode";
import { getAlumniSession, setAlumniSession, clearAlumniSession } from "../config/alumniApi";

const AlumniAuthContext = createContext(null);
export const useAlumniAuth = () => useContext(AlumniAuthContext);

const isTokenValid = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

export const AlumniAuthProvider = ({ children }) => {
  const [alumni, setAlumni] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    clearAlumniSession();
    setAlumni(null);
  }, []);

  useEffect(() => {
    const stored = getAlumniSession();
    if (stored?.token && isTokenValid(stored.token)) {
      setAlumni(stored);
    } else if (stored) {
      logout();
    }
    setLoading(false);
  }, [logout]);

  const login = useCallback((sessionData) => {
    setAlumniSession(sessionData);
    setAlumni(sessionData);
  }, []);

  return (
    <AlumniAuthContext.Provider value={{ alumni, login, logout, loading }}>
      {children}
    </AlumniAuthContext.Provider>
  );
};
